import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

interface IRenameFolderParams {
    folderId: TFolderId;
    newName: string;
}

// $api.interceptors.response.use(
//     (resp) => resp.data,
//     (err) => {
//         const msg = err.response?.data?.message ?? err.message;
//         return Promise.reject(new Error(msg));
//     }
// );

export const renameFolder = async ({
    folderId,
    newName,
}: IRenameFolderParams): Promise<IReturnResponse> => {
    // @ts-ignore
    const route = routable.getRoute('renameFolder').replace('_folderId_', folderId);
    try {
        const formData = new FormData();
        formData.append('name', newName);
        const res = await $api.post<IReturnResponse>(route, formData);
        return res.data;
    } catch (error: any) {
        console.error('renameFolder failed:', error);
        return (
            error?.response?.data || {
                status: 'error',
                data: null,
                message: error.message,
            }
        );
    }
};
